import { render, staticRenderFns } from "./UserGroupCreate.vue?vue&type=template&id=8341ed14"
import script from "./UserGroupCreate.vue?vue&type=script&lang=ts"
export * from "./UserGroupCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports